module.exports = __webpack_public_path__ + "img/9788970129020.376e03d0.jpg";